import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { QuoteActions } from '@nibtravel/shared/data-access/quote';
import { LoadCountries } from '@nibtravel/shared/data-access/countries';
import { AppConfigState } from '@nibtravel/shared/util/app-config';

@Injectable({ providedIn: 'root' })
export class QuoteParamGuard implements CanActivate {
  constructor(private router: Router, private store: Store) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree | boolean> {
    const brand = this.store.selectSnapshot(AppConfigState.getBrand);

    return this.store
      .dispatch([new LoadCountries(brand), new QuoteActions.QqcReset()])
      .pipe(
        take(1),
        map(() => {
          return route.queryParamMap.keys.length < 1
            ? this.router.createUrlTree(['/'])
            : true;
        })
      );
  }
}
